import useSWR from "swr";

import { api } from "../services";
import { PaginatedResult } from "../utils/pagination";

const BASE_URL = "/system-admin/departments";

export const useDepartment = (query = {}) => {
  const qs = new URLSearchParams(query).toString();
  const swrKey = `${BASE_URL}?${qs}`;
  const { data, isLoading, mutate } = useSWR(swrKey, api.get);

  const getDepartments = async (pageNumber = 1, pageSize = 10, search = "") => {
    const query = new URLSearchParams();
    query.append("pageNumber", pageNumber);
    query.append("pageSize", pageSize);

    if (search) query.append("search", search);

    const response = await api.getPaginated(`${BASE_URL}?${query.toString()}`);
    return new PaginatedResult(response.data, response.pagination);
  };

  const create = async (data) => {
    const department = await api.post(BASE_URL, data);
    return department;
  };

  const update = async (data) => {
    const department = await api.put(BASE_URL, data);
    return department;
  };

  const find = async (search) => {
    const searchUrl = `${BASE_URL}?search=${search}`;
    const res = await api.get(searchUrl);
    mutate(searchUrl, res, false); // Temporarily mutate new key (optional)
    mutate(searchUrl); // Refetch if needed
    return res;
  };

  return {
    isLoading,
    data,
    count: data?.length,
    getDepartments,
    create,
    update,
    find,
    mutate,
  };
};

export const useDepartmentById = (id) => {
  const { data, isLoading, mutate } = useSWR(`${BASE_URL}/${id}`, api.get);

  const remove = async (id) => {
    const department = await api.delete(`${BASE_URL}/${id}`);
    return department;
  };
  return {
    isLoading,
    data,
    mutate,
    remove,
  };
};
